<template>
  <b-modal
    id="modal-customer-import"
    :title="!importSuccess ? 'Import khách hàng' : 'Import thành công'"
    :size="!importSuccess ? 'md' : 'xl'"
    centered
    hide-footer
    @hidden="resetModal"
  >
    <b-overlay :show="loading">
      <label>Tải xuống file mẫu:</label>
      <button type="button" @click="downloadTemplate" style="color: #259abb">
        &nbsp;&nbsp;Template.xlsx
      </button>

      <form @submit.prevent="handleSubmit">
        <!-- Upload file -->
        <div v-if="!importSuccess" class="py-4">
          <label for="">Import file</label>
          <div class="wrap__file mb-1">
            <span class="file__name">
              {{ file ? fileName : 'file import.xlsx' }}
            </span>
            <b-icon-upload
              scale="1.5"
              class="cursor-pointer"
              @click="$refs.fileUpload.click()"
            ></b-icon-upload>
            <input
              v-show="false"
              type="file"
              id="customer-file-upload"
              ref="fileUpload"
              accept=".xlsx, .xls"
              @change="onUploadFile"
            />
          </div>
          <span v-if="showFileSizeError" class="text-danger">
            Kích thước file import tối đa nhỏ hơn 1MB
          </span>
        </div>

        <!-- Kết quả import -->
        <div v-else>
          <b-row class="mb-4">
            <b-col cols="6" class="d-flex align-items-center">
              <div class="wrap__icon mr-3">
                <span class="svg-icon">
                  <inline-svg src="/media/svg/Active-account/user-group.svg" />
                </span>
              </div>
              <div>
                <h6 class="mb-0">Tổng số bản ghi</h6>
                <p class="mb-0 font-weight-bold">{{ paging.total }}</p>
              </div>
            </b-col>
            <b-col cols="6" class="d-flex align-items-center">
              <div class="wrap__icon mr-3">
                <span class="svg-icon">
                  <inline-svg src="/media/svg/Active-account/check.svg" />
                </span>
              </div>
              <div>
                <h6 class="mb-0">Import thành công</h6>
                <p class="mb-0 font-weight-bold text-success">{{ totalSuccess }}</p>
              </div>
            </b-col>
          </b-row>

          <!-- Result table -->
          <div class="table-responsive">
            <table class="table table-bordered table-sm">
              <thead class="thead-light">
                <tr>
                  <th>STT</th>
                  <th>Họ và tên</th>
                  <th>Số điện thoại</th>
                  <th>Email</th>
                  <th class="text-center">Trạng thái</th>
                  <th>Chi tiết lỗi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pagedResults" :key="idx">
                  <td>{{ (paging.page - 1) * paging.pageSize + idx + 1 }}</td>
                  <td>{{ item.fullName || [item.firstName, item.middleName, item.lastName].filter(Boolean).join(' ') || '—' }}</td>
                  <td>{{ item.phoneMobile || '—' }}</td>
                  <td>{{ item.email || '—' }}</td>
                  <td class="text-center">
                    <div class="status" :class="item.transactionStatus ? 'active' : 'inactive'">
                      {{ item.transactionStatus ? 'Thành công' : 'Lỗi' }}
                    </div>
                  </td>
                  <td>
                    <div v-for="(err, i) in item.errorMessages" :key="i" class="text-danger" style="font-size:0.82rem;">- {{ err }}</div>
                  </td>
                </tr>
                <tr v-if="!pagedResults.length">
                  <td colspan="6" class="text-center text-muted py-4">Không có dữ liệu</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="paging.total > paging.pageSize" class="d-flex justify-content-end mt-2">
            <b-pagination
              v-model="paging.page"
              :total-rows="paging.total"
              :per-page="paging.pageSize"
              size="sm"
            ></b-pagination>
          </div>
        </div>

        <!-- Footer buttons -->
        <div v-if="!importSuccess" class="d-flex justify-content-end align-items-center mt-4">
          <b-button class="btn mr-2" type="button" @click="onClickCancel">Hủy</b-button>
          <b-button
            class="btn btn-success ml-3"
            type="submit"
            :disabled="disableBtnImport || loading"
          >
            <span class="svg-icon mr-1">
              <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
            </span>
            Import
          </b-button>
        </div>

        <div v-else class="d-flex justify-content-end mt-4">
          <b-button class="btn btn-success" type="button" @click="onClickCancel">Đóng</b-button>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import { EXCEL_FILE_TYPE } from '@/core/plugins/constants';

export default {
  name: 'FormCustomerImport',
  data() {
    return {
      loading: false,
      importSuccess: false,
      file: null,
      showFileSizeError: false,
      allResults: [],
      paging: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      totalSuccess: 0,
    };
  },
  computed: {
    fileName() {
      return this.file?.name || '';
    },
    disableBtnImport() {
      return !this.file || this.showFileSizeError;
    },
    pagedResults() {
      const { page, pageSize } = this.paging;
      return this.allResults.slice((page - 1) * pageSize, page * pageSize);
    },
  },
  methods: {
    async downloadTemplate() {
      try {
        const response = await this.$api.get(
          '/AccountHis/download-file?nameFile=Template_Account.xlsx',
          {
            responseType: 'blob',
            headers: {
              'Content-Type':
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
          },
        );
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Template_Account.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Không thể tải file mẫu' });
      }
    },

    onUploadFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (!EXCEL_FILE_TYPE.includes(file.type)) {
        this.$refs.fileUpload.value = null;
        this.$toastr?.e?.({ title: 'Lỗi', msg: 'Chỉ hỗ trợ file .xlsx hoặc .xls' });
        return;
      }

      if (file.size > 1024000) {
        this.showFileSizeError = true;
        return;
      }

      this.file = file;
      this.showFileSizeError = false;
    },

    async handleSubmit() {
      if (this.disableBtnImport) return;

      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('importFile', this.file);

        const { meta, data, error } = await this.$api.post(
          'AccountHis/ImportAccountHis',
          formData,
        );

        if (!meta?.success) {
          this.$toastr?.e?.({ title: 'Lỗi!', msg: error?.message || 'Import thất bại' });
          return;
        }

        const rows = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
        this.allResults = rows.map((el) => ({
          ...el,
          errorMessages: this.parseErrorMessages(el.errorMessage),
        }));
        this.paging.total = data?.total ?? rows.length;
        this.totalSuccess = data?.totalSuccess ?? rows.filter((r) => r.transactionStatus).length;
        this.paging.page = 1;
        this.importSuccess = true;
      } catch (err) {
        this.$toastr?.e?.({ title: 'Lỗi!', msg: err?.message || 'Import thất bại' });
      } finally {
        this.loading = false;
      }
    },

    parseErrorMessages(text) {
      if (!text) return [];
      return text.split('\n').filter((s) => s.trim());
    },

    resetModal() {
      if (this.importSuccess) {
        this.$emit('import-success');
      }
      this.file = null;
      this.showFileSizeError = false;
      this.importSuccess = false;
      this.allResults = [];
      this.paging = { total: 0, page: 1, pageSize: 10 };
      this.totalSuccess = 0;
      if (this.$refs.fileUpload) this.$refs.fileUpload.value = null;
      this.$emit('reset');
    },

    onClickCancel() {
      this.$bvModal.hide('modal-customer-import');
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap__file {
  padding: 10px 16px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    border-color: #aaa;
  }

  .file__name {
    color: #5e6278;
    font-size: 0.9rem;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.wrap__icon {
  background: #e4f5f5;
  border-radius: 8px;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  min-width: 90px;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }
}
</style>

<style lang="scss">
#modal-customer-import {
  .modal-dialog.modal-xl {
    max-width: 1400px;
  }
}
</style>
